module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc",
      "role": "doc-toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/pre2"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/p1"
    }
  }, [_vm._v("Section One: The Three Stones")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/p1chap1"
    }
  }, [_c('b', [_vm._v("1")]), _vm._v(" The Crisis We Face")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/p1chap2"
    }
  }, [_c('b', [_vm._v("2")]), _vm._v(" Unchecked Baggage")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/p1chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3")]), _vm._v(" The First Stone: A Theology of Companionship")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/p1chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Tool 1:")]), _vm._v(" "), _c('i', [_vm._v("What’s in a Picture? Guidelines for Representing Others Through Photography")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/p1chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4")]), _vm._v(" The Second Stone: An Invitation to Cultural Humility")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/p1chap6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("TOOL 2:")]), _vm._v(" "), _c('i', [_vm._v("Seeing into Our Blind Spots: Anticipating and Addressing Cultural Differences")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/p1chap7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5")]), _vm._v(" The Third Stone: The Power of Co-development")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/p1chap8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("TOOL 3:")]), _vm._v(" "), _c('i', [_vm._v("Co-development Evaluation Tool: A Self-Check to Help Leaders Evaluate the Implications of Their Actions in Development Projects")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/p2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Section Two: Using the Three Stones")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/p2chap1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6")]), _vm._v(" Redeeming Short-Term Mission")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/p2chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Tool 4:")]), _vm._v(" "), _c('i', [_vm._v("Preparing for the Journey: Short-Term Mission Orientation Curriculum")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/p2chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Tool 5:")]), _vm._v(" "), _c('i', [_vm._v("Short-Term Mission Daily Reflection Guide")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/p2chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7")]), _vm._v(" Caring for Vulnerable Children and Families")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/p2chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("8")]), _vm._v(" Unbinding Mission Leadership")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/p2chap6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Tool 6:")]), _vm._v(" "), _c('i', [_vm._v("Checklist for Healthy Parish Twinning Relationships")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/p2chap7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Tool 7:")]), _vm._v(" "), _c('i', [_vm._v("Aligning Hearts and Hands: Connecting Mission Funding Allocations to Congregational Values")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appen3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("General Index")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appen4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scripture Index")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("Freeing Congregational Mission")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/fin_acheve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45ad39d7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/sommaire.vue
// module id = 60
// module chunks = 0